import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Select as PrimeSelect } from 'primeng/select';

export type SelectSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'om-select',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, PrimeSelect],
  templateUrl: './select.html',
  styleUrl: './select.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Select {
  control = input.required<FormControl>();
  options = input.required<unknown[]>();
  optionLabel = input<string>('label');
  optionValue = input<string>('');
  placeholder = input<string>('');
  inputId = input<string>('');
  size = input<SelectSize>('md');
  translateOptionLabel = input<boolean>(false);

  readonly sizeClass = computed(() => `om-select--${this.size()}`);

  getLabel(option: unknown): string {
    if (!option || typeof option !== 'object') return '';
    const key = this.optionLabel();
    const value = (option as Record<string, unknown>)[key];
    return typeof value === 'string' ? value : '';
  }
}
